import { createContext, useContext } from 'react';

const PostsContext = createContext(null);

export const usePostsContext = () => {
  const context = useContext(PostsContext);
  if (!context) {
    throw new Error('usePostsContext must be used within a PostsProvider');
  }
  return context;
};

export default PostsContext;
